import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  background: var(--app-bg-gradient);
`;

export const InnerContainer = styled.div`
  min-height: ${({app_status}) => 
    app_status == 'register_land_upload_files' ? '100vh' : '150vh'};
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
`;